export const useStyles = (theme) => ({
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up(960)]: {
      display: "flex",
    },
  },
  cartStyle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});
